var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { alignItems, borderBottom, borderColor, color, display, flexDirection, space, } from 'styled-system';
import { Locale } from '../../common/enums/Locale';
import { useLocalization } from '../../common/providers/LocaleProvider';
import { Text } from '../../common/components/Text';
import { GridItem } from '../../common/components/Grid';
import { linkStyles } from '../../common/components/Link';
var VoucherContainerGrid = styled(GridItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, flexDirection, alignItems, color);
VoucherContainerGrid.defaultProps = {
    w: [1, null, 7 / 12],
    display: 'flex',
    flexDirection: ['column', null, 'row'],
    alignItems: 'center',
};
var Voucher = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  flex: none;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  flex: none;\n"])), display, flexDirection, alignItems, borderBottom, borderColor, space);
Voucher.defaultProps = {
    display: ['none', null, 'flex'],
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: '2px solid',
    borderColor: 'brand.normal',
    mr: ['sp_0', 'sp_24'],
    mb: ['sp_24', null, 'sp_0'],
};
export var CommonText = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  > p {\n    ", ";\n  }\n\n  & a {\n    ", ";\n    color: inherit;\n  }\n"], ["\n  > p {\n    ", ";\n  }\n\n  & a {\n    ",
    ";\n    color: inherit;\n  }\n"])), space, function (props) {
    return linkStyles(__assign({ styled: true, textDecoration: 'underline' }, props));
});
CommonText.defaultProps = {
    fontSize: 'fs_18',
    fontWeight: 'bold',
    lineHeight: '26px',
    textAlign: 'center',
    mt: 'sp_0',
    mb: 'sp_0',
};
var Amount = styled(CommonText)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  & > span {\n    font-size: 36px;\n  }\n"], ["\n  & > span {\n    font-size: 36px;\n  }\n"])));
var Label = styled(CommonText)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  &:after {\n    content: '*';\n    vertical-align: baseline;\n  }\n"], ["\n  &:after {\n    content: '*';\n    vertical-align: baseline;\n  }\n"])));
Label.defaultProps = __assign(__assign({}, CommonText.defaultProps), { fontSize: ['fs_18', null, '22px', '26px'], lineHeight: ['lh_28', null, null, 'lh_32'], fontWeight: 600 });
/** @deprecated component to remove in future */
export var NewsletterVoucher = function (_a) {
    var amount = _a.amount, currency = _a.currency, label = _a.label;
    var locale = useLocalization().locale;
    var isCountryWithCurrencyFirst = [Locale.Nl_Be, Locale.Nl_Nl].includes(locale);
    return (React.createElement(Voucher, null,
        isCountryWithCurrencyFirst ? (React.createElement(Amount, null,
            currency,
            " ",
            React.createElement("span", null, amount))) : (React.createElement(Amount, null,
            React.createElement("span", null, amount),
            " ",
            currency)),
        React.createElement(Label, null, label)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
